import axios from 'axios';

import config from '../config';

axios.defaults.baseURL = config.api.baseUrl;
axios.defaults.withCredentials = true;

export default axios;

